var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCheckCircle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1661_1651)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.8392 5.16016H11.0017C10.8196 5.16016 10.6464 5.24766 10.5392 5.39766L7.73209 9.29051L6.46066 7.52623C6.35352 7.37801 6.18209 7.28873 5.99816 7.28873H5.16066C5.04459 7.28873 4.97673 7.42087 5.04459 7.51551L7.26959 10.6012C7.32215 10.6746 7.39145 10.7344 7.47172 10.7756C7.552 10.8168 7.64095 10.8384 7.7312 10.8384C7.82145 10.8384 7.9104 10.8168 7.99067 10.7756C8.07095 10.7344 8.14024 10.6746 8.1928 10.6012L11.9535 5.38694C12.0232 5.2923 11.9553 5.16016 11.8392 5.16016Z",
    fill: "#0C758C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.5 0C4.08214 0 0.5 3.58214 0.5 8C0.5 12.4179 4.08214 16 8.5 16C12.9179 16 16.5 12.4179 16.5 8C16.5 3.58214 12.9179 0 8.5 0ZM8.5 14.6429C4.83214 14.6429 1.85714 11.6679 1.85714 8C1.85714 4.33214 4.83214 1.35714 8.5 1.35714C12.1679 1.35714 15.1429 4.33214 15.1429 8C15.1429 11.6679 12.1679 14.6429 8.5 14.6429Z",
    fill: "#0C758C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1661_1651"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircle);
export default __webpack_public_path__ + "static/media/check-circle.c3ce836a71fdb178dcb930377a266279.svg";
export { ForwardRef as ReactComponent };